// extracted by mini-css-extract-plugin
module.exports = {"mediaXS":"320px","mediaSM":"544px","mediaMD":"768px","mediaLG":"992px","mediaXL":"1366px"};